import { FaAward } from 'react-icons/fa'
import { TbBooks } from 'react-icons/tb'
import {BiHappyHeartEyes} from 'react-icons/bi'


const data = [
    {
        id : 1,
        icon : <FaAward/>,
        title : 'Experience',
        desc : '1+ years'
    },
    {
        id : 2 ,
        icon : <TbBooks/>,
        title : 'Projects',
        desc : '10+ Projects'
    },
    {
        id : 3 ,
        icon : <BiHappyHeartEyes/>,
        title : 'Clients',
        desc : '5+ clients'
    }
]

export default data